import { Link } from "react-router-dom";
import CommonContext from "../../utils/contexts/CommonContext";
import { useContext, useState, useEffect } from "react";
import details from "../../utils/constants/details.json";
import { useParams, useNavigate } from "react-router-dom";

const MainComponent = () => {
    const { theme, setThemeStatus } = useContext(CommonContext);

    const bodyElement = document.getElementsByTagName("body");
    bodyElement[0].style.backgroundColor = theme.styles.background;

    const { name, role, mail, location, date, tagline } = details;

    const menu = ["feed", "about", "experience", "skills", "education", "projects", "blogs"];

    const url = new URL(window.location.href);

    let currentPath;

    if (url.pathname === "/") {
        currentPath = "/about/";
    } else {
        currentPath = url.pathname;
    }

    const [line, setLine] = useState(currentPath);

    const params = useParams();

    const navigate = useNavigate();

    const mainLayout = (
        <div className="main-component">
            <div className="hs__body pt--130 pb--130">
                <div className="profile-pic"></div>
            </div>

            <div className="profile-info pt--100-60">
                <div>
                    <p className="profile-name" style={{ color: theme.styles.textColor }}>
                        {name}
                    </p>
                    <a className="profile-email" href={`mailto:${mail}`}>
                        {mail}
                    </a>
                    <p className="profile-description" style={{ color: theme.styles.textColor }}>
                        {role}
                    </p>

                    <p className="profile-tagline">{tagline}</p>

                    <div className="profile-description--others">
                        <p className="profile-sub--details">
                            <i className="fa fa-compass" aria-hidden="true"></i> {location}
                        </p>
                        <p className="profile-sub--details">
                            <i className="fa fa-calendar" aria-hidden="true"></i> {date}
                        </p>
                    </div>
                </div>

                <div className="settings-btn">
                    <i
                        className="fa fa-sun-o"
                        aria-hidden="true"
                        style={theme.mode === "light" ? { color: "var(--clr--secondary)", scale: "1.3" } : { color: "var(--clr--subtext)" }}
                        onClick={() => {
                            setThemeStatus({
                                mode: "light",
                            });
                        }}></i>

                    <i
                        className="fa fa-moon-o"
                        aria-hidden="true"
                        style={theme.mode === "dark" ? { color: "var(--clr--primary)", scale: "1.3" } : { color: "var(--clr--subtext)" }}
                        onClick={() => {
                            setThemeStatus({
                                mode: "dark",
                            });
                        }}></i>

                    <i
                        className="fa fa-laptop"
                        aria-hidden="true"
                        style={theme.mode === "system" ? { color: "var(--clr--subtext)", scale: "1.3" } : { color: "var(--clr--subtext)" }}
                        onClick={() => {
                            setThemeStatus({
                                mode: "system",
                            });
                        }}></i>
                </div>
            </div>

            <div className="pt--60-30 profile-tabs">
                <div className="profile-navigation">
                    {menu.map((data) => {
                        return (
                            <div
                                key={data}
                                className="profile-tabs"
                                style={
                                    line.includes(`/${data}`) && !Object.values(params).includes(data)
                                        ? { borderBottom: `4px solid ${theme.styles.accentColor}` }
                                        : { borderBottom: "none" }
                                }>
                                <Link
                                    to={`/${data}/`}
                                    style={{ color: theme.styles.textColor }}
                                    onClick={() => {
                                        window.location.hash = `#focus-point`;

                                        setLine(`/${data}/`);
                                    }}>
                                    {data.charAt(0).toUpperCase() + data.slice(1)}
                                </Link>
                            </div>
                        );
                    })}
                </div>

                {Object.keys(params).length > 0 && (
                    <p
                        className="filter"
                        style={{ color: theme.styles.textColor }}
                        onClick={() => {
                            let parentUrl = line;

                            Object.values(params).forEach((val) => {
                                parentUrl = parentUrl.replaceAll(`/${val}`, "");
                            });

                            navigate(parentUrl);
                        }}>
                        Remove All Filters
                    </p>
                )}
            </div>
        </div>
    );

    // for on-device theme changes
    useEffect(() => {
        const handleColorSchemeChange = (e) => {
            e.matches ? setThemeStatus({ mode: "dark" }) : setThemeStatus({ mode: "light" });
        };

        const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
        mediaQuery.addEventListener("change", handleColorSchemeChange);

        return () => {
            mediaQuery.removeEventListener("change", handleColorSchemeChange);
        };
    }, []);

    return mainLayout;
};

export default MainComponent;
